import type { Me } from '../types/auth'

// ENG-202 §4 — the platform-identity check, kept pure and separate from the
// route guard so it is unit-testable without a DOM.
//
// Deliberately narrower than RequireAdmin's notion of "admin": that guard gates
// the whole operator area and admits consultants and role-less fresh signups
// too. This one is the actual User#role === admin flag, mirroring the backend's
// `current_user&.admin?` bypass in second-brain's authorize_consultant!.
// Mirrors User::CLARITIO_DOMAIN. UX routing only: the server enforces access.
const CLARITIO_DOMAIN = '@claritio.com'

// A signed-in user with no membership, who is neither a platform admin nor
// Claritio staff, has no access to any organization yet.
export function hasNoAccess(me: Me | null | undefined): boolean {
  const user = me?.user
  if (!user) return false
  return (
    user.role === null &&
    user.platform_role !== 'admin' &&
    !user.email.toLowerCase().endsWith(CLARITIO_DOMAIN)
  )
}

// Client-side roles: the customer's own staff, as opposed to operators.
export function isClientRole(role: string | null | undefined): boolean {
  return role === 'employee' || role === 'sponsor'
}

export function isPlatformAdmin(me: Me | null | undefined): boolean {
  return me?.user?.platform_role === 'admin'
}
